/*global angular*/
var activityStatus = angular.module('header', []);
activityStatus.directive('header', ['$state', '$window', '$document', 'settings', function ($state, $window, $document, settings) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./header.html'),
    replace: true,
    transclude: true,
    link: function (scope, element, attrs) {
      scope.showMenu = true;
      scope.toggleMenu = function () {
        if ($window.innerWidth < 920) {
          scope.showMenu = !scope.showMenu;
        }
      };

      function updateWidth(width) {
        if (width > 920) {
          scope.showMenu = true;
        } else {
          scope.showMenu = false;
        }
      }

      updateWidth($window.innerWidth);
      angular.element($window).bind('resize', function () {
        updateWidth($window.innerWidth);
        scope.$digest();
      });

      scope.stateIncludes = $state.includes;

      //Small logo when scroll down
      $document.on('scroll', function () {
        scope.smallLogo = $window.scrollY > 100;
        scope.$apply();
      });
    }
  };
}]);
module.exports = activityStatus;



// WEBPACK FOOTER //
// ./web/js/module/header/header.js